import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const TenancyTemplateLanding = () => (
  <SeoLandingPage
    testIdPrefix="agreement-tenancy"
    pretitle="Agreement Templates · Tenancy"
    title="Free tenancy agreement"
    titleAccent="template — UK · India · Canada"
    description="Download a country-appropriate tenancy template generated by Shopperden AI. Includes the standard clauses for AST (UK), Model Tenancy Act (India) and provincial leases (Canada). Every template is clearly watermarked AI-Generated and must be reviewed by a qualified solicitor / advocate before use."
    ctaLabel="Generate template"
    ctaTo="/login"
    secondaryCtaLabel="Tenant guide"
    secondaryCtaTo="/tenant-guide"
    bullets={[
      { title: 'Country-correct', body: 'AST clauses for UK, Model Tenancy Act format for India, provincial leases for Canada — drafted by AI, reviewed by you.' },
      { title: 'Editable', body: 'Get a structured draft with placeholders ([LANDLORD NAME], [RENT], [DATES]). Fill in, customise, and export.' },
      { title: 'Watermarked & disclaimed', body: 'Every page carries an AI-Generated · Shopperden stamp + a clear "not legal advice" footer. Designed for transparency, not deception.' },
    ]}
    faq={[
      { q: 'Is this a legally binding contract?', a: 'No. The template is a starting point only. It is clearly watermarked AI-Generated. You MUST have it reviewed and signed off by a qualified solicitor (UK), advocate (India) or licensed lawyer (Canada) before use. Using it without professional review may make it unenforceable.' },
      { q: 'Why the watermark?', a: 'To prevent AI-generated drafts being passed off as solicitor-prepared documents. Transparency protects both landlords and tenants.' },
      { q: 'Can I remove the watermark?', a: 'No. Removing or tampering with the Shopperden AI-Generated watermark violates our terms and may expose you to liability if the document is later challenged in court.' },
    ]}
    seoTitle="Free Tenancy Agreement Template — AST, Model Tenancy Act, Provincial Lease | Shopperden"
    seoDescription="Country-correct tenancy agreement templates for UK, India and Canada. AI-generated, clearly watermarked, must be reviewed by a solicitor before use."
    softwareApplication={{
      name: 'Shopperden AI Tenancy Agreement Drafter',
      category: 'BusinessApplication',
      subCategory: 'LegalApplication',
      description: 'AI-powered tenancy agreement template generator. Outputs country-correct AST (UK), Model Tenancy Act (India) and provincial lease (Canada) drafts.',
      features: [
        'AST template (UK)',
        'Model Tenancy Act format (India)',
        'Provincial lease format (Canada)',
        'Editable placeholders',
        'AI-Generated watermark',
      ],
      rating: { value: '4.6', count: '78' },
    }}
  />
);

export default TenancyTemplateLanding;
